export default {
  signIn: 'Logga in',
  signOut: 'Logga ut',
  points: 'poäng',
  hyattSignInButton: 'Logga in på World of Hyatt',
};
